import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import ProjectHeader from "../../../components/Header/ProjectHeader";
import Footer from "../../../components/Footer/index";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import DaysCard from "../../../components/Card/DaysCard";
import { Typography } from "@mui/material";
import * as acts from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import BatchStepper from "../../../components/Stepper/BatchStepperCpvAuto";
import CustomizedSnackbar from "../../../components/Snackbars/CustomizedSnackbars";
import Progressbar from "../../../components/ProgressBar";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import "./uploadPdfAgainstBatch.scss";
import constantValues from "../../../constants/constantValues";
import { preProRoutes } from "../../../routes/routeConstants";

const UploadPdfAgainstBatch = () => {
  const dispatch = useDispatch();
  const tags = useSelector((state) => state?.prePro?.tags);
  const uploadedBatchPdfs = useSelector(
    (state) => state?.prePro?.uploadedBatchPdfs
  );
  const [checked, setChecked] = React.useState(true);
  const [actualFilesListData, setActualFilesListData] = useState({
    loading: false,
    error: false,
    errorMsg: "",
    data: [],
  });
  const [selectedFiles, setSelectedFiles] = useState([
    {
      tagName: "",
      pdfPath: "",
      pdfName: "",
    },
  ]);
  const [uploadPdfSucces, setuploadPdfSuccess] = useState(false);
  // const [uploadPdfError, setUploadPdfError] = useState(false);
  const [footerDisable, setFooterDisable] = useState(true);
  const [load, setLoad] = useState(true);
  const [message, setMessage] = useState("");
  const fileType = "actual_pdfs";
  const subFolder = localStorage.drugType;
  const { TEXT_EXTRACTION } = constantValues;

  useEffect(() => {
    dispatch(acts.getTags(localStorage.projectId));
    dispatch(acts.getTagsAndPdf(localStorage.projectId, localStorage.batchId));
    dispatch(acts.getS3Files(fileType, subFolder));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const navigate = useNavigate();
  const drugType = useSelector((state) => state?.prePro?.drugType);
  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.loader === false) {
        if (apiStatus?.messages !== undefined) {
          setMessage(apiStatus?.messages);
          if (apiStatus?.next === true) {
            setuploadPdfSuccess(true);
            setTimeout(() => {
              // navigate("/pre-processor-dashboard");
              navigate(`/${preProRoutes.preProDashboard}`) 
            }, 2000);
            dispatch(acts.clearApiStatus());
          } else if (
            apiStatus?.next === false &&
            apiStatus?.message !== null &&
            apiStatus.apiError === true
          ) {
            // setUploadPdfError(true);
            setMessage(apiStatus.message);
          }
        }
      }
    }

    if (drugType && drugType?.data) {
      setActualFilesListData({
        loading: false,
        error: false,
        errorMsg: "",
        data: drugType?.data,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus, drugType]);
  const handleChange = (index, pdfName, pdfPath, tagName) => {
    //actual batch record upload
    setFooterDisable(false);
    const updatedFiles = [...selectedFiles];
    updatedFiles[index] = {
      tagName: tagName,
      pdfPath: pdfPath,
      pdfName: pdfName,
    };
    setSelectedFiles(updatedFiles);
  };
  const handleCheckBoxClick = (event) => {
    setChecked(event.target.checked);
  };
  const handleClick = (event, action) => {
    if (action === "previous") {
      // navigate("/pre-processor-dashboard");
      navigate(`/${preProRoutes.preProDashboard}`) 
    } else if (action === "save") {
      const next = false;
      dispatch(
        acts.uploadBatchPdfs(
          selectedFiles,
          localStorage.projectId,
          localStorage.batchId,
          checked,
          next
        )
      );
    } else if (action === "continue") {
      const next = true;
      dispatch(
        acts.uploadBatchPdfs(
          selectedFiles,
          localStorage.projectId,
          localStorage.batchId,
          checked,
          next
        )
      );
    }
  };
  useEffect(() => {
    // set here the uploaded pdf to state variable which is "selectedFiles"
    let files = [];
    if (uploadedBatchPdfs?.length > 0) {
      uploadedBatchPdfs.map((item) => {
        files.push({
          pdfPath: item.pdfpath,
          pdfName: item.original_filename,
          tagName: item.tagname,
        });
      });

      setSelectedFiles(files);
      setFooterDisable(false);
      setLoad(false);
    } else {
      setLoad(false);
    }
  }, [uploadedBatchPdfs]);
  useEffect(() => {
    setLoad(true);
  }, []);

  return (
    <>
      {/* <ThemeProvider theme={theme}> */}
      <div>
        <Header />
        <BatchStepper currentStep={1} />
        <ProjectHeader
          position="center"
          headerColor="#F5F5F5"
          text={localStorage.projectName + "-" + localStorage.batchName}
        />

        <Box className="uploadpdf-main-container">
          {!load && tags && tags?.data?.tags?.length > 0 && (
            <Typography variant="subtitle1" className="tag-style">
              Tags ({tags && tags?.data?.tags?.length})
            </Typography>
          )}
          <Box className="uploadpdf-card-container">
            <Grid container spacing={3}>
              {load ? (
                <Progressbar />
              ) : (
                tags &&
                tags?.data?.tags?.length > 0 &&
                tags?.data?.tags?.map((tagName, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={2}
                      sm={4}
                      md={4}
                      className="pdfcard"
                    >
                      <DaysCard
                        tagName={tagName}
                        actualFilesListData={actualFilesListData?.data}
                        handleChange={handleChange}
                        cardIndex={index}
                        selectedFiles={selectedFiles}
                        uploadedBatchPdfs={uploadedBatchPdfs}
                      />
                    </Grid>
                  );
                })
              )}
            </Grid>
            {!load && (
              <div className="checkBox">
                <Checkbox
                  checked={checked}
                  onChange={handleCheckBoxClick}
                  inputProps={{ "aria-label": "controlled" }}
                />
                {TEXT_EXTRACTION}
              </div>
            )}
          </Box>
        </Box>

        <Footer
          isPrevious={false}
          isNextDisable={footerDisable !== true ? false : true}
          isPreviousDisable={true}
          isSaveDisable={footerDisable !== true ? false : true}
          onHandleClick={(event, action) => handleClick(event, action)}
        />
        {actualFilesListData.error && (
          <CustomizedSnackbar
            severity="error"
            state={actualFilesListData.error}
            text={message}
            handleClose={() => setActualFilesListData.error(false)}
          />
        )}
        {uploadPdfSucces && (
          <CustomizedSnackbar
            severity="success"
            state={uploadPdfSucces}
            text={message}
            handleClose={() => setuploadPdfSuccess(false)}
          />
        )}

        {apiStatus.loader && <Progressbar />}
      </div>
    </>
  );
};
export default UploadPdfAgainstBatch;
